import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum WorkDataSuggestionEvaluationStateEnum {
    inProgress = 'inProgress',
    closed = 'closed',
}

export const workDataSuggestionEvaluationStateEnumOptions = enumToOptions(WorkDataSuggestionEvaluationStateEnum, 'workData.suggestion.enum.state.');
